import { render, staticRenderFns } from "./DownloadWithCustomLogoBtn.vue?vue&type=template&id=b0e263ba&scoped=true"
import script from "./DownloadWithCustomLogoBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadWithCustomLogoBtn.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e263ba",
  null
  
)

export default component.exports